import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./DateView.module.css";

const DateView = (props) => {
  const { date } = props;

  return (
    <p className={classes["date-view"]}>
      <span className={classes["date-view__day"]}>
        {new Date(date).toLocaleDateString("ar-eg", {
          weekday: "long",
        })}
      </span>
      <span
        className={classNames(classes["date-view__date"], "numeric-content")}
      >
        {new Date(date).getUTCDate()} / {new Date(date).getUTCMonth() + 1}
      </span>
    </p>
  );
};

export default DateView;

DateView.propTypes = {
  date: PropTypes.string,
};
